module.exports = __webpack_public_path__ + "img/stock5.52cfb00a.png";